export default "__VITE_ASSET__30b3027e__"